import { useMutation, useQueryClient } from 'react-query';

const useOptimisticMutation = (
    queryKey,
    mutate,
    update,
    invalidateQueriesOnSettled = true,
) => {
    const qc = useQueryClient();
    const mutationConfig = {
        onMutate: (variables) => {
            // cancel any outbound request
            qc.cancelQueries(queryKey);

            const snapshot = qc.getQueryData(queryKey);

            // optimistic update
            qc.setQueryData(queryKey, (prevCache) =>
                update(prevCache, variables),
            );

            // rollback
            return () => qc.setQueryData(queryKey, snapshot);
        },
        onError: (err, id, rollback) => rollback(),
        retry: 3,
    };

    if (invalidateQueriesOnSettled) {
        mutationConfig.onSettled = () => qc.invalidateQueries(queryKey);
    }

    return useMutation(mutate, mutationConfig);
};

export default useOptimisticMutation;
